import Vue from 'vue'
import Vuetify, {
	VLayout
} from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
	iconfont: 'md',
	theme: {
        primary: '#673ab7',
        secondary: '#e91e63',
        accent: '#607d8b',
        error: '#f44336',
        warning: '#00bcd4',
        info: '#ff9800',
        success: '#4caf50',
        dull: '#f5f5f5',
        dull_mid: '#BDBDBD'
	},
	components: {
		VLayout
	}
})

// // Ori color theme
// Vue.use(Vuetify, {
// 	iconfont: 'md',
// 	theme: {
// 		primary: '#673ab7',
// 		secondary: '#e91e63',
// 		accent: '#607d8b',
// 		error: '#f44336',
// 		warning: '#00bcd4',
// 		info: '#ff9800',
// 		success: '#4caf50'
// 	},
// 	components: {
// 		VLayout
// 	}
// })